import React from "react";

function Result({ output }) {
  if (!output) return null;

  const resultClass = output.type === "bunk" ? "text-green-500" : "text-red-500";
  
  return (
    <div className={`result ${resultClass}`}>
      <p className={`text-lg font-semibold ${resultClass}`}>{output.message}</p>
    </div>
  );
}

export default Result;
